import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CreateGoodDTO  {
    _originalTypeClassName = "zERP.BO.CreateGoodDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CreateGoodDTO.translate = translateService;
}
this.AssetCategory = new Domain.AssetCategory();
this.Name = null;
this.Code = null;
this.Description = null;
this.Type = null;
this.CreateGoodDTOKey = null;
this._key = this.CreateGoodDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Code:any;
Description:any;
Type:any;
AssetCategory:any;
Entity:any;
VATRate:any;
GoodCat:any;
private _CreateGoodDTOKey:any;
get CreateGoodDTOKey(): any {
    return this._CreateGoodDTOKey;
  }
set CreateGoodDTOKey(value: any) {
    this._CreateGoodDTOKey = value;
    this._key = value;
  }
static setAssetCategory = ($this, value) => {
var oldValue = $this.AssetCategory;
$this.AssetCategory = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setVATRate = ($this, value) => {
var oldValue = $this.VATRate;
$this.VATRate = value;
if (value != null) {
}
}
static setGoodCat = ($this, value) => {
var oldValue = $this.GoodCat;
$this.GoodCat = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CreateGoodDTOKey == null || $this.CreateGoodDTOKey == 0;
            }


}